import React, { Fragment } from "react";
import * as MD from "@material-ui/core";
import { usePagination, useSortBy, useTable } from "react-table";
import "../react-table.css";
import { BiPlayCircle } from "react-icons/bi";
import { I18N } from "../Store/I18n/Types";
import { DrawSelect } from "./Sidebar/DrawSelect";
import { ISearchState } from "../Store/Search/Types";

import { YacastPlayer } from "@yacast/react-player";
import '@yacast/react-player/dist/index.css'
import { IUserState } from "../Store/User/Types";
import { capitalize } from "../Utils/String";
import { Dispatch } from "redux";
import { IApplicationState } from "../Store";
import { connect } from "react-redux";
import { IAdvancedSearchPlayerFilters, IEmissionSearchFilters, IPlayerRapidSearchFilters, IPlayerState } from "../Store/Player/Types";
import { getEmissionSearch, getPlayerAdvancedSearch, getPlayerRapidSearch } from "../Store/Player/Actions";
import moment from "moment";
import styled from "styled-components";
import { Export } from "./Dashboard/Export";
import { IDashboardState, IFiltersDetail } from "../Store/Dashboard/Types";
import _ from "lodash";
import { getExportDashboardDetailsPdf, getExportDashboardDetailsXls } from "../Store/Export/Actions";
import { Dialog } from "./Dialog";

const Styles = styled.div `
  table {
    width: 100%;
    border-spacing: 0;
    border: 1px solid black;
    tr {
      :last-child {
        td {
          border-bottom: 0;
        }
      }
    }
    th,
    td {
      margin: 0;
      padding: 2px;
      :last-child {
        border-right: 0;
      }
    }
  }
  
  .pagination {
    padding: 0.1rem;
    background-color: darkgray;
    display: block;
    text-align: center;
  }
`
const styles = (theme:any) => MD.createStyles({
    root: {
      width: "100%",
    },
    paper: {
      width: "100%",
      clear:"both",
      marginBottom: theme.spacing(2),
    },
    table: {
      minWidth: 750,
    },
    toggleDiv:{
      width:"100%",
    },
    closeButton: {
      position: 'absolute',
      right: '8px',
      top: '5px',
      color: theme.palette.grey[500],
    },
  });

interface IPropsFromState {
  i18n: I18N;
  player: IPlayerState;
  search: ISearchState;
  user: IUserState;
  dashboard: IDashboardState;
}

interface IPropsFromDispatch {
  getPlayerRapidSearch: typeof getPlayerRapidSearch
  getEmissionSearch: typeof getEmissionSearch
  getPlayerAdvancedSearch: typeof getPlayerAdvancedSearch
  getExportDashboardDetailsPdf: typeof getExportDashboardDetailsPdf
  getExportDashboardDetailsXls: typeof getExportDashboardDetailsXls
}
  
interface IOwnProps {
  data: any,
  type: string,
  rowPlayingID?: number;
  hideMediaFilter?: boolean,
}

type AllProps =
    MD.WithTheme &
    MD.WithStyles &
    IPropsFromState &
    IPropsFromDispatch &
    IOwnProps;

interface IOwnState {
  originalData: any[];
  data: any[];
  columns: any[];
  mediasID: number[];
  mediasStr: string[];
  isAllMediaSelected: boolean;
  programTypesID: number[];
  programTypesStr: string[];
  isAllProgramTypesSelected: boolean;
  programEditorsID: number[] | null;
  programEditorsStr: string[];
  isAllProgramEditorsSelected: boolean;
  openPlayer: boolean;
  mediaIDtoPlay:number;
  rowPlayingID: number;
  mediaNametoPlay:string;
  startDatetoPlay:number;
  endDatetoPlay:number;
}
interface ITableProps {
  columns: any,
  data: any,
  rowPlayingID: number
}

function hiddenColumns(columns:any) {
  let hiddenColumns:any = [] // array of id type string
  hiddenColumns = columns.filter((x:any) => x.show === false)
  hiddenColumns = hiddenColumns.map((x:any) => x.accessor)
  return hiddenColumns
}
function setThStyle(column:any) {
  if (column.id === 'date' || column.id === 'heure' || column.id === "duree") {
    return {
      ...column.headerStyle,
      width: '70px'
    }
  } else if (column.id === 'fonction' || column.id === 'intervenant') {
      return {
        ...column.headerStyle,
        width: '150px'
      }
  } else {
    return {
      ...column.headerStyle,
    }
  }
  
}

function setTrStyle(row:any, index: any, rowPlayingId?: number) {
  let style:any = {
    backgroundColor: index % 2 === 0 ? "rgb(68, 68, 78)" : "rgb(68, 68, 78, 0.97)",
    lineHeight: '15px',
    padding: 2
  }
  if (row.index === rowPlayingId) { 
    style= {
      ...style,
      backgroundColor: 'gray'
    }
  }
  return style
}
function setTdStyle(cell:any) {
  return (
    {
      textAlign: cell.column.id === 'type_emission' || cell.column.id === 'emission' ? 'left' : 'center'
    }
  )
}
function Table(props:ITableProps) { 
  let columns:any = props.columns
  let data:any = props.data
  const {
    getTableProps, 
    getTableBodyProps, 
    headerGroups, 
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageIndex, pageSize }
  } = 
  useTable({
    columns, 
    data,
    initialState: {
      hiddenColumns: hiddenColumns(columns),
      pageIndex: 0, pageSize: 20 
    },
  },
  useSortBy,
  usePagination
  )

  const generateSortingIndicator = (column:any) => {
    return column.isSorted ? (column.isSortedDesc ? ' 🔽' : ' 🔼') : '';
  };
  // Render Data Table UI
  return (
    <Fragment>
    <table {...getTableProps()} 
    style={{
      borderColor: '#bdabab',
      background: 'rgb(218, 218, 218)',
      color: '#f6f1f1',
      fontWeight: 300,
    }}
    className="-striped -highlight">
      <thead>
        {headerGroups.map(headerGroup => {
          return (
            <tr {...headerGroup.getHeaderGroupProps()} >
              {headerGroup
                .headers
                .map((column:any, index:number) => {
                return (
                  <th {...column.getHeaderProps(column.getSortByToggleProps())}
                  style={{
                    ...setThStyle(column)
                  }}
                  title=''
                  >
                    {column.render('Header')}
                    {generateSortingIndicator(column)}
                  </th>
                )})
              }
            </tr>
          )}
        )}
      </thead>
      <tbody {...getTableBodyProps()}>
        {page.map((row, i) => {
          if (row !== null) {
            prepareRow(row);
            return (
              <Fragment key={row.getRowProps().key}>
              <tr
              style={setTrStyle(row, i, props.rowPlayingID)}
              >
                {row
                  .cells
                  .map((cell:any) => {
                    return (
                    <td {...cell.getCellProps()}
                    style={setTdStyle(cell) as any} 
                    >{cell.render('Cell')}</td>)
                  })}
              </tr>
              </Fragment>
            )
          } else return null
        })}
      </tbody>
    </table>
    
    <div className="pagination">
        <button onClick={() => gotoPage(0)} disabled={!canPreviousPage}>
          {'<<'}
        </button>{' '}
        <button onClick={() => previousPage()} disabled={!canPreviousPage}>
          {'<'}
        </button>{' '}
        <button onClick={() => nextPage()} disabled={!canNextPage}>
          {'>'}
        </button>{' '}
        <button onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}>
          {'>>'}
        </button>{' '}
        <span style={{color: 'black'}}>
          Page{' '}
          <strong>
            {pageIndex + 1} de {pageOptions.length}
          </strong>{' '}
        </span>
        <select
          style={{width: '50px', padding: '1.5px'}}
          value={pageSize}
          onChange={e => {
            setPageSize(Number(e.target.value))
          }}
        >
          {[10, 20, 30, 40, 50].map(pageSize => (
            <option key={pageSize} value={pageSize} style={{color: 'black', textAlign: 'center' }}>
              {pageSize}
            </option>
          ))}
        </select>
      </div>
    </Fragment>
  )
}

export class TableDetailsComponent extends React.Component<AllProps, IOwnState> {
    public constructor(props: AllProps) {
        super(props);
        this.state = {
          originalData: [],
          data: [],
          columns: [],
          mediasID: props.user.allMediasID,
          mediasStr: props.user.allMediasSTR,
          isAllMediaSelected: true,
          programTypesID: props.search.allProgramTypesID,
          programTypesStr: props.search.allProgramTypesSTR,
          isAllProgramTypesSelected: true,
          programEditorsID: null,
          programEditorsStr: props.search.allProgramEditorsSTR,
          isAllProgramEditorsSelected: true,
          openPlayer: false,
          mediaIDtoPlay: -1,
          rowPlayingID: -1,
          mediaNametoPlay: '',
          startDatetoPlay: -1,
          endDatetoPlay: -1,
        }
    }
    public componentDidUpdate(prevProps: AllProps, prevState:IOwnState){
      if (!_.isEqual(prevProps.dashboard.filters, this.props.dashboard.filters) && this.props.type === 'dashboard') {
        let filters = this.props.dashboard.filters
        this.setState({
            mediasStr: filters.media_str,
            mediasID: filters.media_ids,
            programEditorsID: filters.program_editors_ids,
            programEditorsStr: filters.program_editors_str,
            programTypesID: filters.program_type_ids,
            programTypesStr: filters.program_type_str,
            isAllMediaSelected: filters.media_ids.length === this.props.user.allMediasID.length,
            isAllProgramEditorsSelected: filters.program_editors_ids.length === this.props.search.allProgramEditorsID?.length,
            isAllProgramTypesSelected: filters.program_type_ids.length === this.props.search.allProgramTypesID.length
        })
      }
    }
    static getDerivedStateFromProps(props: AllProps, state: IOwnState) {
      if (props.type === 'player') {
        if (props.player.playerRapidSearchFilters !== null) {
          state.mediasID = props.player.playerRapidSearchFilters.media_ids
          state.mediasStr = props.player.playerRapidSearchFilters.media_str
          state.programTypesID = props.player.playerRapidSearchFilters.program_type_ids
          state.programTypesStr = props.player.playerRapidSearchFilters.program_type_str
          state.programEditorsID = props.player.playerRapidSearchFilters.program_editor_ids
          state.programEditorsStr = props.player.playerRapidSearchFilters.program_editor_str
          state.isAllMediaSelected = props.player.playerRapidSearchFilters.isAllMediaSelected
          state.isAllProgramEditorsSelected = props.player.playerRapidSearchFilters.isAllProgramEditorsSelected
          state.isAllProgramTypesSelected = props.player.playerRapidSearchFilters.isAllProgramTypesSelected
        }
        if (props.player.emissionSearchFilters !== null) {
          state.mediasID = props.player.emissionSearchFilters.media_ids
          state.mediasStr = props.player.emissionSearchFilters.media_str
          state.programTypesID = props.player.emissionSearchFilters.program_type_ids
          state.programTypesStr = props.player.emissionSearchFilters.program_type_str
          state.programEditorsID = props.player.emissionSearchFilters.program_editor_ids
          state.programEditorsStr = props.player.emissionSearchFilters.program_editor_str
          state.isAllMediaSelected = props.player.emissionSearchFilters.isAllMediaSelected
          state.isAllProgramEditorsSelected = props.player.emissionSearchFilters.isAllProgramEditorsSelected
          state.isAllProgramTypesSelected = props.player.emissionSearchFilters.isAllProgramTypesSelected
        }
        if (props.player.advancedSearchPlayerFilters !== null) {
          state.mediasID = props.player.advancedSearchPlayerFilters.media_ids
          state.mediasStr = props.player.advancedSearchPlayerFilters.media_str
          state.programTypesID = props.player.advancedSearchPlayerFilters.program_type_ids
          state.programTypesStr = props.player.advancedSearchPlayerFilters.program_type_str
          state.programEditorsID = props.player.advancedSearchPlayerFilters.program_editor_ids
          state.programEditorsStr = props.player.advancedSearchPlayerFilters.program_editor_str
          state.isAllMediaSelected = props.player.advancedSearchPlayerFilters.isAllMediaSelected
          state.isAllProgramEditorsSelected = props.player.advancedSearchPlayerFilters.isAllProgramEditorsSelected
          state.isAllProgramTypesSelected = props.player.advancedSearchPlayerFilters.isAllProgramTypesSelected
        }
      }
      if (props.type === 'dashboard') {
        if (props.dashboard.filters !== null && state.programEditorsID === null) {
          let filters = props.dashboard.filters
          state.mediasID = filters.media_ids
          state.mediasStr = filters.media_str
          state.programTypesID = filters.program_type_ids
          state.programTypesStr = filters.program_type_str
          state.programEditorsID = filters.program_editors_ids
          state.programEditorsStr = filters.program_editors_str
          state.isAllMediaSelected = filters.media_ids.length === props.user.allMediasID.length
          state.isAllProgramEditorsSelected = filters.program_editors_ids.length === props.search.allProgramEditorsID?.length
          state.isAllProgramTypesSelected = filters.program_type_ids.length === props.search.allProgramTypesID.length
        }
      }
      return state
    }

    private handleVideoPlayerClick = (event:React.MouseEvent<SVGSVGElement, MouseEvent>,row: any, mediaID:number) => {
      event.stopPropagation();
      event.preventDefault();
      this.setState({
        openPlayer: true,
        mediaIDtoPlay: mediaID,
        mediaNametoPlay: row.original.mediaName,
        startDatetoPlay: (new Date(row.original.startDate)).getTime(),
        endDatetoPlay: (new Date(row.original.endDate)).getTime(),
        rowPlayingID: row.index
      })
    }

    private buildColumns() {
      const { i18n, theme } = this.props
      let dataCopy:any = []
      let headerStyle= {
        backgroundColor: "#dadada",
        color: 'black',
        flex: '100 0 auto',
        fontSize: '0.875rem',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        fontWeight: 300,
        width: '100px',
        cursor: 'pointer'
      }
      this.props.data.map((x:any) => {
        let jsonData:any = {}
        jsonData["media"] = x.media_name
        jsonData["date"] = x.day
        jsonData["heure"] = x.time
        jsonData["type_emission"] = x.emission_type_name || x.typeemission_name
        jsonData["emission"] = x.emission_name || x.broadcast_libelle
        jsonData["editeur"] = x.program_editor_name || x.editeur_name
        jsonData["intervenant"] = x.person_name
        jsonData["fonction"] = x.function
        jsonData["appartenance"] = x.political_group_name
        jsonData["regime"] = x.political_regime_name
        jsonData["duree"] = x.duration_hms
        jsonData["player"] = ""
        jsonData["mediaName"] = x.media_name
        jsonData["editorId"] = x.program_editor_id || x.editeur_id
        jsonData["mediaId"] = x.media_id
        jsonData["programId"] = x.emission_type_id || x.typeemission_id
        jsonData["startDate"] = x.date_start
        jsonData["endDate"] = x.date_end
        
        dataCopy.push(jsonData)
        return dataCopy
      })
      let columns:any = []
      dataCopy.map((x:any) => {
        Object.keys(x).map((key:any, index: number) => {
          if (key === "type_emission") {
            columns[index] = {
                Header: "Type Emission",
                accessor: 'type_emission',
                show: true,
                headerStyle: {
                  ...headerStyle,
                  width: '200px'
                },
                Cell: (cell:any) => {
                  return <div style={{display:'inline-flex'}} title={cell.value}>
                    {cell.row.original.programId === 1 ? 
                    <span
                      style={{
                        display: "block",
                        marginRight: "3px",
                        width: "25px",
                        height: "25px",
                        textAlign: "center",
                        border: "solid 1px #888",
                        fontWeight:500,
                        backgroundColor: '#8a8a2f'
                      }}
                    >
                      J
                    </span> :
                    cell.row.original.programId === 2 ?
                    <span 
                      style={{ 
                        display: "block",
                        marginRight: "3px",
                        width: "25px",
                        height: "25px",
                        textAlign: "center",
                        border: "solid 1px #888",
                        fontWeight:500,
                        backgroundColor: '#286f28'
                      }}
                    >
                      P
                    </span> :
                    <span 
                      style={{
                        display: "block",
                        marginRight: "3px",
                        width: "25px",
                        height: "25px",
                        textAlign: "center",
                        border: "solid 1px #888",
                        fontWeight:500,
                        backgroundColor: '#335c69'
                      }}
                    >
                      M
                  </span>
                    }
                    {cell.value}
                    </div>;
                },
            }
          } else if (key === 'player') {
            columns[index] = {
                Header: "Player",
                accessor: "player",
                show: true,
                headerStyle: {
                  ...headerStyle,
                  width: '50px'
                },
                minWidth: 50,
                Cell: (cell:any) => {
                  let media_id = cell.row.original.mediaId
                  let medias_source = this.props.search.mediasSource
                  let media_source_id:any = null
                  if (medias_source !== undefined && medias_source !== null) {
                    if (Object.keys(medias_source).length > 0) {
                      Object.keys(medias_source).map((key:any) => {
                        if(parseInt(key) === media_id) {
                          let media_source = medias_source[key]
                          if (media_source !== undefined && media_source[0] !== undefined && media_source[0] !== null) {
                            media_source_id = media_source[0].id
                          }
                        }
                        return media_source_id
                      })
                    }
                  }
                  if (media_source_id !== null) {
                    return (
                      <div style={{display: 'inline-flex'}}>
                        <MD.IconButton 
                        title={i18n._('Play selection')}
                        onClick={(event:any) => this.handleVideoPlayerClick(event, cell.row, media_source_id)}
                        >
                          <BiPlayCircle 
                          style={{ cursor: 'pointer', marginRight: '10px', fontSize:'smaller', color: theme.palette.primary.light }}
                          />
                        </MD.IconButton>
                        {/* <MD.IconButton 
                        title={i18n._('Download')}
                        >
                          <BiDownload style={{ cursor: 'pointer', fontSize:'smaller', color: theme.palette.primary.light }}/>
                        </MD.IconButton> */}
                        </div>
                    );
                  } else return null
                },
              }
          } else {
            if (x[key] === undefined || key === "mediaName" || key === "mediaId" || key === "editorId" || key === "programId" || key === "startDate" || key === "endDate") {
              columns[index] = {
                Header: capitalize(i18n._(`${key}`)),
                accessor: key,
                show: false,
              }
            } else if (key === 'date') {
              columns[index] = {
                Header: capitalize(i18n._(`${key}`)),
                id: key,
                accessor: (row:any) => {
                  return row.startDate
                },
                show: true,
                headerStyle: {
                  ...headerStyle,
                  width: '70px'
                },
                Cell: (cell:any) => {
                  return  <span title={cell.row.original.startDate}>
                            {moment(cell.row.original.startDate).format('DD/MM/YYYY')}
                          </span>
                }
              }
            } else {
              columns[index] = {
                Header: capitalize(i18n._(`${key}`)),
                accessor: key,
                show: true,
                headerStyle: headerStyle,
                Cell: (cell:any) => {
                  return  <span title={cell.value}>
                            {cell.value}
                          </span>
                }
              }
            }
          } 
          return columns
        })
        return columns
      })
      
      this.setState({ columns: columns, data: dataCopy, originalData: dataCopy})
    }

    componentDidMount() {
      this.buildColumns()
    }

    private handleClose = () => {
      this.setState({
        openPlayer: false,
        rowPlayingID: -1
      });
    }
    private showVideoPlayer(tokenPlayer:string, mediaID:number, mediaName:string, startDate:number, endDate:number){
      let duration = (endDate - startDate) / 1000;
      let timelineDuration = duration + (30 * 60)
      return(
        <Dialog 
          closeDialog={this.handleClose.bind(this)} 
          open={this.state.openPlayer} 
          width={'700px'}
          content={
            <YacastPlayer
                apiKey={tokenPlayer}
                mediaName={mediaName}
                mediaID={mediaID}
                start={new Date(startDate - 1000)}
                autoplay={true}
                timelineDuration={timelineDuration}
                timelineHaveReadjustedEPG={true}
                timelineHaveMusicEPG={false}
                selectionEnd={new Date(endDate)}
                selectionStart={new Date(startDate)}
                initialZoom={0}
                aclToken={this.props.user.token}
              />
          } 
        />
      )
    }
    // --------------> medias update
    private updateMedias(id:number, name:string) {
      let newState = {...this.state}
      let dataCopy = newState.originalData
      dataCopy = dataCopy.filter(x => x.mediaId === id)
      if (this.state.programEditorsID !== null && !this.state.isAllProgramEditorsSelected) {
        let list:any = this.state.programEditorsID
        dataCopy = dataCopy.filter(x => x.editorId === list[0])
      }
      if (!this.state.isAllProgramTypesSelected) {
        dataCopy = dataCopy.filter(x => x.programId === this.state.programTypesID[0])
      }
      newState.mediasID = [id]
      newState.mediasStr = [name]
     
      if (this.props.type === 'player') {
        switch(this.props.player.currentSearch) {
          case 'rapid':
            if (this.props.player.playerRapidSearchFilters !== null) {
              let filters = {...this.props.player.playerRapidSearchFilters}
              return (
                this.props.getPlayerRapidSearch({
                  ...filters,
                  media_ids: [id],
                  media_str: [name],
                  isAllMediaSelected: false
                })
              )
            }
            return null
          case 'emission':
            if (this.props.player.emissionSearchFilters !== null) {
              let filters = {...this.props.player.emissionSearchFilters}
              return (
                this.props.getEmissionSearch({
                  ...filters,
                  media_ids: [id],
                  media_str: [name],
                  isAllMediaSelected: false
                },
                this.props.player.tableLabel)
              )
            }
            return null
          case 'advanced':
            if (this.props.player.advancedSearchPlayerFilters !== null) {
              let filters = {...this.props.player.advancedSearchPlayerFilters}
              return (
                this.props.getPlayerAdvancedSearch({
                  ...filters,
                  media_ids: [id],
                  media_str: [name],
                  isAllMediaSelected: false
                })
              )
            }
            return null
        }
      }
      this.setState({
          ...newState,
          isAllMediaSelected: false,
          data: dataCopy
      })
    }
    private handleAllMedias() {
      let newState = {...this.state}
      let dataCopy = newState.originalData
      
      if (!this.state.isAllProgramEditorsSelected) {
        let list:any = this.state.programEditorsID
        dataCopy = dataCopy.filter(x => x.editorId === list[0])
      }
      if (!this.state.isAllProgramTypesSelected) {
        dataCopy = dataCopy.filter(x => x.programId === this.state.programTypesID[0])
      }
        this.setState({
            mediasID: this.props.user.allMediasID,
            mediasStr: this.props.user.allMediasSTR,
            isAllMediaSelected: true,
            data: dataCopy
        })
        if (this.props.type === 'player') {
          switch(this.props.player.currentSearch) {
            case 'rapid':
              if (this.props.player.playerRapidSearchFilters !== null) {
                let filters = {...this.props.player.playerRapidSearchFilters}
                return (
                  this.props.getPlayerRapidSearch({
                    ...filters,
                    media_ids: this.props.user.allMediasID,
                    media_str: this.props.user.allMediasSTR,
                    isAllMediaSelected: true
                  })
                )
              }
              return null
            case 'emission':
              if (this.props.player.emissionSearchFilters !== null) {
                let filters = {...this.props.player.emissionSearchFilters}
                return (
                  this.props.getEmissionSearch({
                    ...filters,
                    media_ids: this.props.user.allMediasID,
                    media_str: this.props.user.allMediasSTR,
                    isAllMediaSelected: true
                  },
                  this.props.player.tableLabel)
                )
              }
              return null
            case 'advanced':
              if (this.props.player.advancedSearchPlayerFilters !== null) {
                let filters = {...this.props.player.advancedSearchPlayerFilters}
                return (
                  this.props.getPlayerAdvancedSearch({
                    ...filters,
                    media_ids: this.props.user.allMediasID,
                    media_str: this.props.user.allMediasSTR,
                    isAllMediaSelected: true
                  })
                )
              }
              return null
          }
        }
    }
   // --------------> programTypes update
   private updateProgramTypes(id:number, name:string) {
    let newState = {...this.state}
    let dataCopy = newState.originalData
    dataCopy = dataCopy.filter(x => x.programId === id)
    if (!this.state.isAllProgramEditorsSelected) {
      let list:any = this.state.programEditorsID
      dataCopy = dataCopy.filter(x => x.editorId === list[0])
    }
    if (!this.state.isAllMediaSelected) {
      dataCopy = dataCopy.filter(x => x.mediaId === this.state.mediasID[0])
    }
    newState.programTypesID = [id]
    newState.programTypesStr = [name]
    this.setState({
        ...newState,
        isAllProgramTypesSelected: false,
        data: dataCopy
    })
    if (this.props.type === 'player') {
      switch(this.props.player.currentSearch) {
        case 'rapid':
          if (this.props.player.playerRapidSearchFilters !== null) {
            let filters = {...this.props.player.playerRapidSearchFilters}
            return (
              this.props.getPlayerRapidSearch({
                ...filters,
                program_type_ids: [id],
                program_type_str: [name],
                isAllProgramTypesSelected: false
              })
            )
          }
          return null
        case 'emission':
            if (this.props.player.emissionSearchFilters !== null) {
              let filters = {...this.props.player.emissionSearchFilters}
              return (
                this.props.getEmissionSearch({
                  ...filters,
                  program_type_ids: [id],
                  program_type_str: [name],
                  isAllProgramTypesSelected: false
                },
                this.props.player.tableLabel)
              )
            }
            return null
          case 'advanced':
            if (this.props.player.advancedSearchPlayerFilters !== null) {
              let filters = {...this.props.player.advancedSearchPlayerFilters}
              return (
                this.props.getPlayerAdvancedSearch({
                  ...filters,
                  program_type_ids: [id],
                  program_type_str: [name],
                  isAllProgramTypesSelected: false
                })
              )
            }
            return null
      }
    }
  }
  private handleAllProgramTypes() {
    let newState = {...this.state}
    let dataCopy = newState.originalData
      
    if (!this.state.isAllProgramEditorsSelected) {
      let list:any = this.state.programEditorsID
      dataCopy = dataCopy.filter(x => x.editorId === list[0])
    }
    if (!this.state.isAllMediaSelected) {
      dataCopy = dataCopy.filter(x => x.mediaId === this.state.mediasID[0])
    }
      this.setState({
          programTypesID: this.props.search.allProgramTypesID,
          programTypesStr: this.props.search.allProgramTypesSTR,
          isAllProgramTypesSelected: true,
          data: dataCopy
      })
      if (this.props.type === 'player') {
        switch(this.props.player.currentSearch) {
          case 'rapid':
            if (this.props.player.playerRapidSearchFilters !== null) {
              let filters = {...this.props.player.playerRapidSearchFilters}
              return (
                this.props.getPlayerRapidSearch({
                  ...filters,
                  program_type_ids: this.props.search.allProgramTypesID,
                  program_type_str: this.props.search.allProgramTypesSTR,
                  isAllProgramTypesSelected: true
                })
              )
            }
            return null
          case 'emission':
            if (this.props.player.emissionSearchFilters !== null) {
              let filters = {...this.props.player.emissionSearchFilters}
              return (
                this.props.getEmissionSearch({
                  ...filters,
                  program_type_ids: this.props.search.allProgramTypesID,
                  program_type_str: this.props.search.allProgramTypesSTR,
                  isAllProgramTypesSelected: true
                },
                this.props.player.tableLabel)
              )
            }
            return null
          case 'advanced':
            if (this.props.player.advancedSearchPlayerFilters !== null) {
              let filters = {...this.props.player.advancedSearchPlayerFilters}
              return (
                this.props.getPlayerAdvancedSearch({
                  ...filters,
                  program_type_ids: this.props.search.allProgramTypesID,
                  program_type_str: this.props.search.allProgramTypesSTR,
                  isAllProgramTypesSelected: true
                })
              )
            }
            return null
        }
      }
  }
  // --------------> programEditors update
  private updateProgramEditors(id:number, name:string) {
      let newState = {...this.state}
      let dataCopy = newState.originalData
      dataCopy = dataCopy.filter(x => x.editorId === id)
      if (!this.state.isAllMediaSelected ) {
        dataCopy = dataCopy.filter(x => x.mediaId === this.state.mediasID[0])
      }
      if (!this.state.isAllProgramTypesSelected) {
        dataCopy = dataCopy.filter(x => x.programId === this.state.programTypesID[0])
      }
      newState.programEditorsID = [id]
      newState.programEditorsStr = [name]
      this.setState({
          ...newState,
          isAllProgramEditorsSelected: false,
          data: dataCopy
      })
      if (this.props.type === 'player') {
        switch(this.props.player.currentSearch) {
          case 'rapid':
            if (this.props.player.playerRapidSearchFilters !== null) {
              let filters = {...this.props.player.playerRapidSearchFilters}
              return (
                this.props.getPlayerRapidSearch({
                  ...filters,
                  program_editor_ids: [id],
                  program_editor_str: [name],
                  isAllProgramEditorsSelected: false
                })
              )
            }
            return null
          case 'emission':
            if (this.props.player.emissionSearchFilters !== null) {
              let filters = {...this.props.player.emissionSearchFilters}
              return (
                this.props.getEmissionSearch({
                  ...filters,
                  program_editor_ids: [id],
                  program_editor_str: [name],
                  isAllProgramEditorsSelected: false
                },
                this.props.player.tableLabel)
              )
            }
            return null
          case 'advanced':
            if (this.props.player.advancedSearchPlayerFilters !== null) {
              let filters = {...this.props.player.advancedSearchPlayerFilters}
              return (
                this.props.getPlayerAdvancedSearch({
                  ...filters,
                  program_editor_ids: [id],
                  program_editor_str: [name],
                  isAllProgramEditorsSelected: false
                })
              )
            }
            return null
        }
      }
  }
  private handleAllProgramEditors() {
      let newState = {...this.state}
      let dataCopy = newState.originalData
      if (!this.state.isAllMediaSelected ) {
        dataCopy = dataCopy.filter(x => x.mediaId === this.state.mediasID[0])
      }
      if (!this.state.isAllProgramTypesSelected){
        dataCopy = dataCopy.filter(x => x.programId === this.state.programTypesID[0])
      }
      this.setState({
          programEditorsID: this.props.search.allProgramEditorsID,
          programEditorsStr: this.props.search.allProgramEditorsSTR,
          isAllProgramEditorsSelected: true,
          data: dataCopy
      })
      if (this.props.type === 'player') {
        switch(this.props.player.currentSearch) {
          case 'rapid':
            if (this.props.player.playerRapidSearchFilters !== null && this.props.search.allProgramEditorsID !== null) {
              let filters = {...this.props.player.playerRapidSearchFilters}
              return (
                this.props.getPlayerRapidSearch({
                  ...filters,
                  program_editor_ids: this.props.search.allProgramEditorsID,
                  program_editor_str: this.props.search.allProgramEditorsSTR,
                  isAllProgramEditorsSelected: true
                })
              )
            }
            return null
          case 'emission':
            if (this.props.player.emissionSearchFilters !== null && this.props.search.allProgramEditorsID !== null) {
              let filters = {...this.props.player.emissionSearchFilters}
              return (
                this.props.getEmissionSearch({
                  ...filters,
                  program_editor_ids: this.props.search.allProgramEditorsID,
                  program_editor_str: this.props.search.allProgramEditorsSTR,
                  isAllProgramEditorsSelected: true
                },
                this.props.player.tableLabel)
              )
            }
            return null
          case 'advanced':
            if (this.props.player.advancedSearchPlayerFilters !== null && this.props.search.allProgramEditorsID !== null) {
              let filters = {...this.props.player.advancedSearchPlayerFilters}
              return (
                this.props.getPlayerAdvancedSearch({
                  ...filters,
                  program_editor_ids: this.props.search.allProgramEditorsID,
                  program_editor_str: this.props.search.allProgramEditorsSTR,
                  isAllProgramEditorsSelected: true
                })
              )
            }
            return null
        }
      }
  }

  getTrProps = (state:any, rowInfo:any, instance:any) => {
    if (rowInfo) {
      return {
        style: {
          height: '25px'
        }
      }
    }
    return {};
  }

  private drawTable() {
    return (
      this.state.data.length > 0 ?
      <Styles>
        <Table
          rowPlayingID={this.state.rowPlayingID}
          data={this.state.data} 
          columns={this.state.columns}
        />
      </Styles>    
      : <div>
            {this.props.i18n._('No results')}  
        </div>      
    )
  }

  private buildDetailsDashboardExport() {
    const { dashboard } = this.props;
    let filters:IFiltersDetail = {
      political_regime_ids: dashboard.detailsFilters.political_regime_ids,
      political_group_ids: dashboard.detailsFilters.political_group_ids,
      media_ids: this.state.mediasID,
      program_type_ids: this.state.programTypesID,
      program_editor_ids: [],
      time_slot_start: dashboard.detailsFilters.time_slot_start,
      time_slot_end: dashboard.detailsFilters.time_slot_end,
      date_start: dashboard.detailsFilters.date_start,
      date_end: dashboard.detailsFilters.date_end,
      study_type_id: dashboard.detailsFilters.study_type_id
    }
    if (this.state.programEditorsID !== null) {
      filters = {
        ...filters,
        program_editor_ids: this.state.programEditorsID
      }
    }
    return (
      <div style={{position: 'absolute', right: '15px', display: 'inline-flex'}}>
          <Export exportAction={this.props.getExportDashboardDetailsPdf}
          filters={filters} exportType = 'pdf' />
          <Export exportAction={this.props.getExportDashboardDetailsXls}
          filters={filters} exportType = 'xls' />
      </div>
  )}
  private saveMediasChanges(ids: number[], str: string[], bool: boolean) {
    this.setState({
        mediasID: ids,
        mediasStr: str,
        isAllMediaSelected: bool
    })
  }
  render() {
    const { i18n } = this.props;
    return ( 
      <div id="details-table"> 
        { this.state.openPlayer &&
          this.showVideoPlayer(
            this.props.user.tokenPlayer,
            this.state.mediaIDtoPlay, 
            this.state.mediaNametoPlay, 
            this.state.startDatetoPlay,
            this.state.endDatetoPlay
          ) 
          }
        <div id="select-filters" style={{display: 'inline-flex', width: '60%', paddingBottom: '10px'}}>
          {
            ! this.props.hideMediaFilter && this.state.mediasID.length > 0 &&
            <div style={{width: "30%"}}>
            <DrawSelect 
              i18n={i18n} 
              title= {i18n._('Medias')}
              list={this.props.user.medias} 
              listID={this.state.mediasID}
              listStr={this.state.mediasStr}
              isAllSelected={this.state.isAllMediaSelected}
              allListIDs={this.props.user.allMediasID}
              allListStr={this.props.user.allMediasSTR}
              saveChanges={this.saveMediasChanges.bind(this)}
              multiple={false}
            />
            </div>
          }
          { this.props.search.programTypes.length > 0 &&
          <div style={{width: "30%"}}>
          <DrawSelect 
            i18n={i18n} 
            title= {i18n._('Program types')}
            list={this.props.search.programTypes} 
            listID={this.state.programTypesID}
            listStr={this.state.programTypesStr}
            isAllSelected={this.state.isAllProgramTypesSelected}
            allListIDs={this.props.search.allProgramTypesID}
            allListStr={this.props.search.allProgramTypesSTR}
            updateList={this.updateProgramTypes.bind(this)}
            handleAllList={this.handleAllProgramTypes.bind(this)}
            multiple={false}
          />
          </div>
          } 
          {
            this.props.search.allProgramEditorsID !== null && this.state.programEditorsID !== null && this.props.search.programEditors.length > 0 &&
            <div style={{width: "30%"}}>
            <DrawSelect 
            i18n={i18n} 
            title= {i18n._('Program editors')}
            list={this.props.search.programEditors} 
            listID={this.state.programEditorsID}
            listStr={this.state.programEditorsStr}
            isAllSelected={this.state.isAllProgramEditorsSelected}
            allListIDs={this.props.search.allProgramEditorsID}
            allListStr={this.props.search.allProgramEditorsSTR}
            updateList={this.updateProgramEditors.bind(this)}
            handleAllList={this.handleAllProgramEditors.bind(this)}
            multiple={false}
            />
            </div>
          }
          {
            this.props.type === 'dashboard' &&
            this.buildDetailsDashboardExport()
          }
        </div>
        { this.drawTable() }
      </div>
    )
  }
}

const mapStateToProps = ({i18n, player, search, user, dashboard} : IApplicationState) => {
  return {
    i18n: i18n.i18n,
    player,
    search,
    user,
    dashboard
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
    getPlayerRapidSearch: (filters: IPlayerRapidSearchFilters) => dispatch(getPlayerRapidSearch(filters)),
    getEmissionSearch: (filters: IEmissionSearchFilters, emission_name:string) => dispatch(getEmissionSearch(filters, emission_name)),
    getPlayerAdvancedSearch: (filters: IAdvancedSearchPlayerFilters) => dispatch(getPlayerAdvancedSearch(filters)),
    getExportDashboardDetailsPdf: (filters: any) => dispatch(getExportDashboardDetailsPdf(filters)),
    getExportDashboardDetailsXls: (filters: any) => dispatch(getExportDashboardDetailsXls(filters)),

});

export const TableDetails = 
    connect(mapStateToProps, mapDispatchToProps)
    (MD.withTheme(MD.withStyles(styles)(TableDetailsComponent)));
